import React from "react";
/* eslint-disable */
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const cultivatedDetails = this.props.cultivatedDetailsList;
    const data = this.props.searchData;

    const totalCultivatedQty = cultivatedDetails.reduce((sum, row) => sum + parseFloat(row.cultivatedQty), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const totalSuppliedQty = cultivatedDetails.reduce((sum, row) => sum + parseFloat(row.suppliedQty), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return (
      <div>
        <h3><center><u>Supplied Qty against Cultivated Qty Report</u></center></h3>
        <div>&nbsp;</div>
        {/* <Grid style={{ padding: '20px' }} container spacing={1}>
          <Grid md={2} xs={2}>
            <h4>Group:</h4>
          </Grid>
          <br />
          <Grid md={10} xs={10}>
            {data.groupID}
          </Grid>
          <br />
          <Grid md={2} xs={2}>
            <h4>Fresh Collection Center:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.operationEntityID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product Category:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropCategoryID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>From:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {new Date(data.fromDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>To:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {new Date(data.toDate).toLocaleDateString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
          </Grid>

        </Grid> */}
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'left'}>SKU Code</TableCell>
                  <TableCell align={'left'}>SKU Description</TableCell>
                  <TableCell align={'right'}>Cultivated Qty</TableCell>
                  <TableCell align={'right'}>Supplied Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cultivatedDetails.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {moment(data.orderDate).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productDescription}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.cultivatedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.suppliedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell align={'left'} component="th" scope="row" style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    Total
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ fontWeight: 'bold', borderBottom: "none" }}></TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ fontWeight: 'bold', borderBottom: "none" }}></TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {totalCultivatedQty}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {totalSuppliedQty}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
